import ActionTypes from "./ActionTypes";

const getYardsalesList = (payload) => {
  return {
    type: ActionTypes.GET_YARDSALES,
    payload: payload,
  };
};

const clearYardsalesList = () => {
  return {
    type: ActionTypes.CLEAR_YARDSALES,
  };
}

const onDeactivateYardsale = (payload) => {
  return {
    type: ActionTypes.DEACTIVATE_YARDSALE,
    payload: payload,
  };
};

const getYardsaleDetails = (payload) => {
  return {
    type: ActionTypes.GET_YARDSALE_DETAILS,
    payload: payload,
  };
};



export { getYardsalesList, getYardsaleDetails, clearYardsalesList, onDeactivateYardsale };
